import { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { DatasourceContext } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/DataSourcesBuilderPage'
import { Datasource } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/interfaces'

function useDatasource(
  ensure: true
): readonly [Datasource, (valueOrUpdater: Datasource | ((datasource: Datasource) => Datasource)) => void]
function useDatasource(
  ensure?: false
): readonly [Datasource | undefined, (valueOrUpdater: Datasource | ((datasource?: Datasource) => Datasource)) => void]
function useDatasource(
  ensure = false
): readonly [Datasource | undefined, (valueOrUpdater: Datasource | ((datasource?: Datasource) => Datasource)) => void] {
  const history = useHistory()
  const [datasource, setDatasource] = useContext(DatasourceContext)

  useEffect(() => {
    if (ensure && !datasource) {
      history.push('/')
    }
  }, [history, ensure, datasource])

  return [datasource, setDatasource]
}
export default useDatasource
